<template>
  <div
    class="outer-box d-flex flex-column  justify-content-center py-16 px-20"
    @click.stop="toggleScalePop">
    <Scalepopup-tag
      name="BRIGHTNESS"
      class="py-3" />
    <Scalepopup-tag
      name="CONTRAST"
      class="mt-12 py-3"/>
    <Scalepopup-tag
      name="SATURATION"
      class="mt-12 py-3"/>
    <Scalepopup-tag
      name="BLUR"
      class="mt-12 py-3"/>
    <Scalepopup-tag
      name="X-PROCESS"
      class="mt-12 py-3"/>
    <Scalepopup-tag
      name="VIGNETTE"
      class="mt-12 py-3"/>
  </div>
</template>
<script>

import Scalepopup from '../Slider/Slider.vue';

export default {
  name:       'Scalepopup',
  components: {
    'Scalepopup-tag': Scalepopup,
  },
  data() {
    return {
    };
  },
  methods: {
    toggleScalePop() {

    },
  },
};

</script>
<style lang="scss" scoped>
    .outer-box{
        width:368px;
        height:356px;
        box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.06), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04);
        border-radius: 4px;
        position:fixed;
        z-index: 100;
        background: #ffff;
        left: 205px;
        top: 500px;
    }

    @media screen and (min-width: 1540px ) {
        .outer-box{
            left: 230px;
        }
    }
    @media screen and (min-width: 1601px ) {
        .outer-box{
            left: 260px;
        }
    }

    @media screen and (min-width: 1650px ) {
        .outer-box{
            left: 290px;
        }
    }

    @media screen and (min-width: 1706px ) {
        .outer-box{
            left: 300px;
        }
    }
    @media screen and (min-width: 1906px ) {
        .outer-box{
            left: 320px;
        }
    }
</style>
